import React, { useState } from "react"

import useAudioInputDevices from "components/AudioRoom/useAudioInputDevices"
import useJoinAudioRoom from "components/AudioRoom/useJoinAudioRoom"

import TeacherJoinModal from "./TeacherJoinModal"
import TeacherRoom from "./TeacherRoom"

type TeacherAudioRoomProps = {
  audioRoomId: string
  currentUserId: string
}

const TeacherAudioRoom: React.FC<TeacherAudioRoomProps> = ({
  audioRoomId,
  currentUserId,
}) => {
  const [fatalError, setFatalError] = useState<string>()
  const {
    chimeJoinInfo,
    controlsUnlockedUserIds,
    onJoin,
    isJoining,
    joinError,
  } = useJoinAudioRoom(audioRoomId)
  const {
    audioInputDevices,
    selectedAudioInputDeviceId,
    setSelectedAudioInputDeviceId,
    selectedAudioInputDeviceName,
    microphoneError,
  } = useAudioInputDevices()
  const displayedError = fatalError || joinError

  return (
    <div className="min-h-screen overflow-hidden bg-[#111] text-white">
      {displayedError ? (
        <p className="p-6 text-center italic text-white/60">{displayedError}</p>
      ) : !chimeJoinInfo ? (
        <TeacherJoinModal
          audioRoomId={audioRoomId}
          audioInputDevices={audioInputDevices}
          selectedAudioInputDeviceId={selectedAudioInputDeviceId}
          setSelectedAudioInputDeviceId={setSelectedAudioInputDeviceId}
          microphoneError={microphoneError}
          onJoin={onJoin}
          joining={isJoining}
        />
      ) : (
        <TeacherRoom
          joinInfo={chimeJoinInfo}
          onFatalError={setFatalError}
          audioRoomId={audioRoomId}
          currentUserId={currentUserId}
          audioInputDeviceId={selectedAudioInputDeviceId}
          audioInputDeviceName={selectedAudioInputDeviceName}
          controlsUnlockedUserIds={controlsUnlockedUserIds}
        />
      )}
    </div>
  )
}

export default TeacherAudioRoom
